import type React from 'react';

interface Props {
  title: string;
  children?: React.ReactNode;
  headerChildren?: React.ReactNode;
}

export default function ({ title, headerChildren, children }: Props) {
  return (
    <div className="flex flex-col space-y-2">
      <div className="flex items-center justify-between">
        <span className="font-medium">{title}</span>
        {headerChildren}
      </div>
      {children}
    </div>
  );
}
